import { render } from "./DropDownNotification.vue?vue&type=template&id=a0646426&scoped=true"
import script from "./DropDownNotification.vue?vue&type=script&lang=js"
export * from "./DropDownNotification.vue?vue&type=script&lang=js"

import "./DropDownNotification.vue?vue&type=style&index=0&id=a0646426&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0646426"]])

export default __exports__